(function () {

    angular
      .module('meanApp')
      .directive('burgerSpinner', burgerSpinner);
  
    function burgerSpinner () {
        return {
            restrict: 'E',
            replace: true,
            /*scope : {
            'recipe': '=',
            'size' : '@'
            },*/
            templateUrl: '/common/directives/spinner/burger.spinner.template.html'
        };
    }
  
})();